import { MediaQuery } from '@mantine/core';
import React from 'react';

export default function NoPrint({ children, disabled }: React.PropsWithChildren<{ disabled?: boolean }>) {
	return (
		<MediaQuery
			query="print"
			styles={disabled ? {} : { display: 'none' }}
		>
			{children}
		</MediaQuery>
	);
}
